import { hashQuery, query, is, xenv } from '@didi/webx-js'

function isWeb() {
  return __mpx_mode__ === 'web'
}

function isPassenger() {
  return __mpx_mode__ === 'web' && is('passenger')
}

// 历史上检测过 ua 有 hm 的时候，是街兔小程序，街兔业务已废弃

function isMiniProgram() {
  return __mpx_mode__ === 'wx'
}

function isAliProgram() {
  return __mpx_mode__ === 'ali'
}

function isMiniProgramH5() {
  return __mpx_mode__ === 'web' && xenv() === 'wxmp'
}

function isAliProgramH5() {
  return __mpx_mode__ === 'web' && xenv() === 'alimp'
}
function isDyProgramH5() {
  return __mpx_mode__ === 'web' && xenv() === 'dymp'
}

function isQQH5() {
  return __mpx_mode__ === 'web' && xenv() === 'mqq'
}

function isAliH5() {
  return __mpx_mode__ === 'web' && xenv() === 'alipay'
}

function isWeixinH5() {
  return __mpx_mode__ === 'web' && xenv() === 'weixin'
}

function inAnyMiniProgram() {
  return (
    isMiniProgramH5() ||
    isMiniProgram() ||
    isAliProgramH5() ||
    isAliProgram() ||
    isDyProgramH5()
  )
}

function isWebapp() {
  const { h5source } = Object.assign({}, query(), hashQuery())
  const res =
    xenv() === 'hwfastapp' ||
    h5source === 'webapp' ||
    (__mpx_mode__ === 'web' && __mpx_env__ === 'webapp')
  return res
}

const isOnline =
  __mpx_mode__ === 'web'
    ? process.env.BUILD_ENV !== 'offline'
    : !process.env.IS_OFFLINE
const isPre = process.env.BUILD_ENV === 'pre'
export {
  isWeb,
  isPassenger,
  isWeixinH5,
  isMiniProgram,
  isAliProgram,
  isMiniProgramH5,
  isAliProgramH5,
  isAliH5,
  isQQH5,
  inAnyMiniProgram,
  isDyProgramH5,
  isWebapp,
  isOnline,
  isPre,
}
